module.exports = __webpack_public_path__ + "img/11.1076b936.jpg";